var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overflow-x-hidden leading-relative"},[_c('Highlight'),_vm._v(" "),_c('Header'),_vm._v(" "),_c('main',{staticClass:"relative z-10"},[_c('Nuxt')],1),_vm._v(" "),_c('LazyHydrate',{attrs:{"when-visible":""}},[_c('Footer')],1),_vm._v(" "),_c('noscript',{domProps:{"innerHTML":_vm._s(_vm.cheqTag.noScript)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }